import { render, staticRenderFns } from "./DashboardInscripciones.vue?vue&type=template&id=0dc91a68&"
import script from "./DashboardInscripciones.vue?vue&type=script&lang=js&"
export * from "./DashboardInscripciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports